import { useTranslate } from "ra-core";
import { CreateButton } from "@/components/admin/create-button";
import useAppBarHeight from "../misc/useAppBarHeight";

export const LoadEmpty = () => {
  const translate = useTranslate();
  const appbarHeight = useAppBarHeight();

  return (
    <div
      className="flex flex-col justify-center items-center gap-12"
      style={{
        height: `calc(100dvh - ${appbarHeight}px)`,
      }}
    >
      <img
        src="./img/empty.svg"
        alt={translate("resources.loads.empty.title")}
      />
      <div className="flex flex-col items-center gap-0">
        <h3 className="text-lg font-bold">
          {translate("resources.loads.empty.title")}
        </h3>
        <p className="text-sm text-center text-muted-foreground mb-4">
          {translate("resources.loads.empty.description")}
        </p>
      </div>
      <div className="flex space-x-8">
        <CreateButton label="resources.loads.action.create" />
      </div>
    </div>
  );
};
